import React from 'react'
import './newsletter.css'

import { Container, Row, Col } from 'reactstrap'
import maleTourist from '../assets/images/male-tourist-2.png'

const Newsletter = () => {
  return (
    <section className='newsletter'>
        <Container>
            <Row>
                <Col lg='6'>
                <div className="newsletter__content">
                    <h2>Stay updated with Coast Camping Tours and Safaris</h2>
                    <div className="newsletter__input">
                        <input type="email" placeholder='Enter your email' />
                        <button className="btn newsletter__btn">Subscribe</button>
                    </div>
                    <p>Sign up for our newsletter to receive exclusive offers, exciting new tour packages, and the latest travel tips! Be the first to know about our seasonal specials, new safari destinations, and insider insights into Kenya's hidden gems. Whether you're planning your next adventure or dreaming about a getaway, our newsletter keeps you informed and inspired.</p>

                </div>
                </Col>
                <Col hg='6'>
                <div className="newsletter__img">
                    <img src={maleTourist} alt="" />
                </div>
                </Col>
            </Row>
        </Container>
      
    </section>
  )
}

export default Newsletter
